<div class="modal-header">
    <h5 class="modal-title">Ekipman {{data ? 'Güncelle' : 'Oluştur'}}</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form [formGroup]="equipmendForm" (ngSubmit)="submit()" class="p-1">
    <div class="form-group">
        <label for="name">Ekipman Adı</label>
        <input type="text" id="name" class="form-control" formControlName="name" placeholder="Ekipman adı girin" />
        <div *ngIf="equipmendForm.get('name')?.touched && equipmendForm.get('name')?.invalid" class="text-danger mt-1">
            Ekipman adı zorunludur.
        </div>
    </div>

    <div class="form-row">
        <div class="form-group col-md-3">
            <label for="seriNo">Seri No</label>
            <input type="text" id="seriNo" class="form-control" formControlName="seriNo" placeholder="Seri numarası" />
        </div>

        <div class="form-group col-md-3">
            <label for="kindId">Tür</label>
            <ng-select id="kindId" [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"
                placeholder="Tür seçiniz" [clearable]="true">
            </ng-select>
            <div *ngIf="equipmendForm.get('kindId')?.touched && equipmendForm.get('kindId')?.invalid"
                class="text-danger mt-1">
                Tür seçimi zorunludur.
            </div>
        </div>

        <div class="form-group col-md-3">
            <label for="kindId">Proje</label>
            <ng-select id="projectId" [items]="projects" bindLabel="name" bindValue="id" formControlName="projectId"
                placeholder="Proje seçiniz" [clearable]="true">
            </ng-select>
        </div>

        <div class="form-group col-md-3">
            <label for="isActive">Aktif mi?</label>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="isActive" formControlName="isActive" />
            </div>
        </div>
    </div>



    <div class="form-group">
        <label for="description">Açıklama</label>
        <textarea class="form-control" id="description" rows="3" formControlName="description"
            placeholder="Açıklama yazın..."></textarea>
    </div>

    <div class="modal-footer p-0 pt-3">
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">İptal</button>
        <button type="submit" class="btn btn-primary" [disabled]="equipmendForm.invalid">Kaydet</button>
    </div>
</form>